import React from "react";
import styles from "./styles";
import { Button, IconButton, Paper, withStyles, withTheme } from "@material-ui/core";
import {
  ArrowBack,
  ExpandLess,
  Close,
  LowPriority,
  AddBoxOutlined,
} from "@material-ui/icons";
import Details from "./Details";
import Cards from "./Cards";
import { observer, inject } from "mobx-react";
import { DRIVER_EVENTS } from "../constants";
import constants from "../DispatchPanel/constants"
import {
  completedVsTotalStopsFormatter,
  getTotalDeliveryStops,
  sortStopsBySequence,
} from "../../utils/utils";
import Events from "../../../../../utilities/EventEmitter";
import RefreshWarningBar from "../RefreshWarningBar";
import appConstants from "../../../../../appConstants";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import StyledToolTip from "../../../../common/StyledToolTip";
import ResequenceHelperText from "./ResequenceHelperText";
import { postData } from "../../../../../api/componentAPIs";
import Dialog from "../../../../common/Dialog";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import {
  isStopLocked,
  isStopLockedPermanently,
  getRoutePlacards,
  getProNumbers,
  shouldDisableActionForPreDispatch,
} from "./utils";
import isEqual from "lodash/isEqual";
import { withFeatureFlags } from "../../../../../userProfile/featureFlagsContext";
import { RMAXLogger } from "../../../../../services/LoggerService/RMAXLogger";
import HazmatPlacards from "./HazmatPlacard";
import AddProDialog from "./AddProDialog/index";
import StopMoveFeedbackPanel from "../../../IBPlanning/RoutesView/StopMoveFeedbackPanel";
import { withUserProfile } from "../../../../../userProfile/userProfileContext";
import DropHookMoveModal from "../TrailerDropAndHook/DropHookMoveModal/index";
import LocalShippingOutlinedIcon from "../utils/DriverStatus/Icons/LocalShippingOutlinedIcon";
import StopImagesDialog from "./StopImagesDialog"
import { STOP_IMAGES } from "./StopImagesDialog/getBlobImages";
import TerminalCard from "./TerminalStopCard";
import { withAppConfig } from "../../../../../appConfigContext";
import { totalUnAckPickupsValueGetter } from '@dataGrid/components/cellRenderer';

@inject("DispatchStore")
@observer
class DriverPopup extends React.Component {
  constructor(props) {
    super(props);
    this.cardContainerRef = React.createRef();
    this.state = {
      isExpanded: this.props.defaultExpanded || false,
      routeData: this.props.routeData,
      currentDriverRoutes: this.getCurrentDriverRoutes(
        this.props.routeData.driverId
      ),
      resequencingInProgress: false,
      showResequenceHelperText: false,
      showPendingChangesWarning: false,
      showConfirmation: false,
      stopsWithoutDelays: null,
      isAddProInProgress: false,
      isOpenDropHookMoveModal: false,
      viewStopImages: null
    };
    this.feedbackPanelKey = null;
    this.portalItem = null;
    this.isResequenceSuccess = false; // If resequence request is complete, update data in component did update
    this.enableDispatchRouteResequence = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableDispatchRouteResequence
    );
    this.enableDropHookMove = this.props.featureFlags.isFeatureEnabled(
      appConstants.features.EnableDropHookMove
    );
    this.shouldDisableActionForPreDispatch = shouldDisableActionForPreDispatch(this.props.routeData, this.props.configJSON.enablePreDispatch);
  }

  componentDidMount() {
    Events.on("NextStopChanged", this.checkMakeNextStopEvent);
    if (!this._ismounted && this.state.isExpanded) {
      if (!this.props.stopId) {
        this.scrollToIncompleteStop();
      }
    }
    this._ismounted = true;
    if (!this.portalItem) {
      this.portalItem = document.createElement("div");
      this.portalItem.id = "drag";
    }
    document.body.appendChild(this.portalItem);
    Events.on("stopMoved", this.stopMoveCompleted);
    if (this.props.stopId) {
      this.openStopList(this.props.stopId);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.isExpanded && this.state.isExpanded) {
      if (!this.props.stopId) {
        this.scrollToIncompleteStop();
      }
    }
    if (this.props.stopId && this.props.stopId !== prevProps.stopId) {
      this.openStopList(this.props.stopId);
    }
    if (
      prevProps.routeData.driverId !== this.props.routeData.driverId ||
      prevProps.routeData.routeId !== this.props.routeData.routeId
    ) {
      if (this.isStopListUpdated()) {
        this.setState({
          showPendingChangesWarning: true,
        });
      } else {
        this.refreshDriverInfo();
      }
    } else if (
      !this.state.resequencingInProgress &&
      this.state.routeData.routeId === this.props.routeData.routeId &&
      !isEqual(this.state.routeData, this.props.routeData)
    ) {
      // When not in resequencing mode show updated driver status
      this.setState({
        routeData: this.props.routeData,
        currentDriverRoutes: this.getCurrentDriverRoutes(
          this.props.routeData.driverId
        ),
      });
    }
    if (this.isResequenceSuccess) {
      this.refreshDriverInfo();
    }
  }
  
  openStopList = (stopId) => {
    //open list and scroll to selected stop
    if (this.state.isExpanded) {
      this.scrollToSpecificStopCard(stopId);
      return;
    }
    this.setState({ isExpanded: true }, () => this.scrollToSpecificStopCard(stopId));
  };

  scrollToSpecificStopCard = (stopId) => {
    const { routeData } = this.props;
    const stopIndex = sortStopsBySequence(routeData.stops).findIndex(
      (stop) => stop.stopId == stopId
    );
    if (stopIndex >= 0) {
      const scrollValue = this.getStopCardHeightByIndex(stopIndex);
      setTimeout(() => {
        this.handleScrollTo(scrollValue);
      }, 100);
      this.props.DispatchStore.setSelectedStopInKPI(null);
    }
  };

  closeDropHookMoveModal = () => {
    this.setState({ isOpenDropHookMoveModal: false });
  };

  getUpdatedStopSequence = (routeData) => {
    const { currentStatus } = routeData;

    const arrivedStopId =
      currentStatus?.status === DRIVER_EVENTS.ArrivedAtStop
        ? currentStatus?.stopId
        : null;
    return sortStopsBySequence(routeData.stops).find(
      (stop) => !stop.isStopCompleted && stop.stopId !== arrivedStopId
    )?.stopSequence || "";
  };

  checkMakeNextStopEvent = ({ success, kpi }) => {
    const { markedAsNextStopData } = this.state;
    const { routeData } = this.props;
    if (!markedAsNextStopData) {
      // Hide the "Next Stop Feedback" panel for the user if the action is triggered from another window and a SignalR message is received.
      return;
    }
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (success) {
      this.feedbackPanelKey = this.props.enqueueSnackbar("Next Stop Changed", {
        content: (
          <StopMoveFeedbackPanel
            moveType={appConstants.STOP_MOVES.MARK_NEXT_STOP}
            hideUndo
            hideCostKpi
            data={{
              totalTime: kpi?.estimatedTravelTimeDifference,
              totalMiles: kpi?.estimatedMilesDifference,
              numServiceViolations: kpi?.numServiceViolations,
              nextStopMarkedData: markedAsNextStopData,
              updatedStopData: {
                stopSequence: this.getUpdatedStopSequence(routeData),
                stopType: markedAsNextStopData.stopType,
              },
            }}
            onClose={this.onCloseFeedbackPanel}
          />
        ),
        autoHideDuration: 30000,
        style: { pointerEvents: "none" },
      });
    } else {
      this.props.enqueueSnackbar(`Next Stop change failed`, {
        variant: "error",
      });
    }
  };

  onNextStopChangeFailed = (statusCode) => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(`Next Stop change failed`, {
      variant: "error",
    });
  };

  updateNextStop = (markedAsNextStopData) => {
    const { routeData, userData } = this.props;
    const requestParams = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      routeId: routeData.routeId,
      stopId: markedAsNextStopData.stopId,
    };
    RMAXLogger.info("Mark_As_Next_Stop", {
      driverId: requestParams.driverId,
      routeId: requestParams.routeId,
      stopId: requestParams.stopId
    });
    this.setState({
      markedAsNextStopData,
    });
    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      "Stop resequencing",
    ]);
    postData("MarkAsNextStop", requestParams).then(
      (response) => {
        if (response && Math.trunc(response.status / 100) !== 2) {
          this.onNextStopChangeFailed(response.status);
        }
      },
      () => {
        this.onNextStopChangeFailed();
      }
    );
  };

  onCloseFeedbackPanel = () => {
    if (this.feedbackPanelKey !== null) {
      this.props.closeSnackbar(this.feedbackPanelKey);
      this.feedbackPanelKey = null;
    }
  };

  getCurrentDriverRoutes = (driverId) => {
    return this.props.DispatchStore.routesList.filter(
      (route) => route.driverId === driverId
    );
  };

  componentWillUnmount() {
    Events.off("NextStopChanged", this.checkMakeNextStopEvent);
    Events.off("stopMoved", this.stopMoveCompleted);
    Events.off("openStopList", this.openStopList);
    
    this._ismounted = false;
    
    // Fix portal element cleanup
    if (this.portalItem) {
      if (this.portalItem.parentNode) {
        this.portalItem.parentNode.removeChild(this.portalItem);
      }
      this.portalItem = null;
    }
    
  }

  scrollToIncompleteStop = () => {
    const { routeData } = this.props;
    const firstIncompleteStopIndex = sortStopsBySequence(
      routeData.stops
    ).findIndex((stop) => !stop.isStopCompleted);
    const scrollValue = this.getStopCardHeightByIndex(firstIncompleteStopIndex);
    setTimeout(() => {
      this.handleScrollTo(scrollValue);
    }, 100);
  };

  refreshDriverInfo = () => {
    this.setState({
      routeData: this.props.routeData,
      currentDriverRoutes: this.getCurrentDriverRoutes(
        this.props.routeData.driverId
      ),
      resequencingInProgress: false,
      showResequenceHelperText: false,
      showPendingChangesWarning: false,
      showConfirmation: false,
      stopsWithoutDelays: null,
    });
    this.isResequenceSuccess = false;
  };

  stopMoveCompleted = (data) => {
    const { isEventProcessed } = JSON.parse(data);
    this.isResequenceSuccess = isEventProcessed;
  };

  getStopCardHeightByIndex = (stopIndex=0) => {
    const offsetHeights = Array.from({ length: stopIndex}, (_,node) => {
      const childNode =  this.cardContainerRef?.current?.childNodes[0]?.childNodes[node];
      return childNode ? childNode.offsetHeight + 4 : 0;
    }).reduce((partialSum, height) => partialSum + height, 0);
    return offsetHeights;
  };

  handleScrollTo = (scrollValue) => {
    this.cardContainerRef.current?.scroll({
      top: scrollValue,
      behavior: "smooth",
    });
  };

  toggleExpand = () => {
    this.setState((state) => ({
      isExpanded: !state.isExpanded,
    }));
  };

  // During a stop delay currentStatus is DelayStart; derive the arrived/enroute event from
  // arrivedStopId/enrouteStopId, which stay set through the delay.
  getEffectiveCurrentStatus = () => {
    const { routeData } = this.state;
    if (routeData?.arrivedStopId) {
      return { status: DRIVER_EVENTS.ArrivedAtStop, stopId: routeData.arrivedStopId };
    }
    if (routeData?.enrouteStopId) {
      return { status: DRIVER_EVENTS.EnrouteToStop, stopId: routeData.enrouteStopId };
    }
    return routeData?.currentStatus;
  };

  getDriverEnrouteOrArrivedAtStopId = () => {
    const currentStatus = this.getEffectiveCurrentStatus();
    if (
      currentStatus &&
      [DRIVER_EVENTS.ArrivedAtStop, DRIVER_EVENTS.EnrouteToStop].includes(
        currentStatus.status
      )
    ) {
      return currentStatus.stopId;
    }
    return null;
  };

  isDriverCurrentStop = (stopId) => {
    return this.getDriverEnrouteOrArrivedAtStopId() === stopId;
  };

  enableResequencing = () => {
    if (!this.state.resequencingInProgress) {
      this.setState({
        resequencingInProgress: true,
        showResequenceHelperText: true,
        stopsWithoutDelays: sortStopsBySequence(this.props.routeData.stops),
      });
    }
  };

  cancelResequence = () => {
    this.refreshDriverInfo();
  };

  saveResequence = () => {
    const requestData = {
      driverId: this.state.routeData.driverId,
      routeId: this.state.routeData.routeId,
      userId: this.props.userProfile.userId,
      terminalCode: this.props.userProfile.terminal.code,
      stops: this.state.stopsWithoutDelays
        .filter((stop) => stop.isLocked && !stop.isStopCompleted)
        .map((stop, index) => {
          return {
            stopId: stop.stopId,
            sequence: index + 1, // Start sequence from 1,2,3
            isLocked: Boolean(stop.isLocked),
          };
        }),
      eventDateTime: new Date(),
    };

    RMAXLogger.info("StopMoveByDispatcher", {
      manifest: this.state.routeData.manifestNumber,
      userId: this.props.userProfile.userId,
      routeId: this.state.routeData.routeId,
      lockedStopIds: requestData.stops.map((stop) => stop.stopId),
      eventDateTime: requestData.eventDateTime,
    });

    this.props.glEventHub.emit("DispatchEvents", "ShowLoaderDialog", [
      {
        label: "Stop resequencing",
        eventName: "Stop Resequence",
        pickupIds: [],
      },
    ]);
    postData("saveDispatchRouteStopResequence", requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onSaveDispatchStopSequenceFailed(response.status);
        }
      })
      .catch(() => {
        this.onSaveDispatchStopSequenceFailed();
      });
  };

  refreshStopList = () => {
    Events.emit(
      appConstants.DISPATCH_EVENTS.UPDATE_DISPATCH_DRIVER_ROUTES,
      this.state.routeData.driverId
    );
  };

  changeRouteData = (routeId) => { 
    if (!routeId) {
      return;
    }
    const selectedDriverRoute = this.state.currentDriverRoutes.find(
      (route) => route.routeId === routeId.value
    );
    const newSelectedRoutes =
      this.props.DispatchStore.selectedRouteNameList.map((route) =>
        route === this.state.routeData.routeId ? routeId.value : route
      );
    if (selectedDriverRoute) {
      selectedDriverRoute.color = this.state.routeData.color;
      this.setState({ routeData: selectedDriverRoute });
      this.props.DispatchStore.updateSelectedDriverRouteId(
        selectedDriverRoute.routeId
      );
      this.props.glEventHub.emit(
        "UpdateDispatchStore",
        "updateSelectedRoutes",
        [newSelectedRoutes]
      );
    }
  };

  onSaveDispatchStopSequenceFailed = (statusCode) => {
    this.props.glEventHub.emit("DispatchEvents", "HideLoaderDialog", []);
    if (statusCode === 403) {
      return;
    }
    this.props.enqueueSnackbar(
      `Failed to update stop sequence for driver ${this.state.routeData.driverName}, route ${this.state.routeData.routeName}`,
      { variant: "error" }
    );
  };

  onLockChanged = (stopSequence, isLocked) => {
    if (isLocked) {
      // If Locking a stop lock all the stops in sequence before the stops
      this.setState((state) => ({
        stopsWithoutDelays: state.stopsWithoutDelays.map((stop) => {
          if (stop.stopSequence <= stopSequence) {
            return {
              ...stop,
              isLocked,
            };
          }
          return stop;
        }),
      }));
    } else {
      // If unlocked stop is completed skip unlocking
      const isStopCompleted = this.state.stopsWithoutDelays.find(
        (stop) => stop.stopSequence === stopSequence
      )?.isStopCompleted;
      if (isStopCompleted) {
        return;
      }
      // Unlocking a non completing stop should unlock all stops after selected stop
      this.setState((state) => ({
        stopsWithoutDelays: state.stopsWithoutDelays.map((stop) => {
          if (stop.stopSequence >= stopSequence) {
            return {
              ...stop,
              isLocked,
            };
          }
          return stop;
        }),
      }));
    }
  };

  showConfirmationModal = () => {
    this.setState({
      showConfirmation: true,
    });
  };

  onCloseConfirmation = (confirmed) => {
    if (confirmed) {
      this.saveResequence();
    }
    this.setState({
      showConfirmation: false,
    });
  };

  hideResequenceHelperText = () => {
    this.setState({
      showResequenceHelperText: false,
    });
  };

  isDragDisabled = (stop) => {
    return (
      !this.state.resequencingInProgress ||
      isStopLocked(stop, this.state.routeData.currentStatus)
    );
  };

  onClosePendingChangesWarning = (confirmed) => {
    if (confirmed) {
      this.saveResequence();
      setTimeout(() => {
        this.refreshDriverInfo();
      }, 10000);
    } else {
      this.refreshDriverInfo();
    }
    this.setState({
      showPendingChangesWarning: false,
    });
  };

  // Drag & drop  methods

  onDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination) {
      // dropped outside droppable area
      return;
    }

    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      // no change in position
      return;
    }

    let destinationIndex = destination.index;
    const firstDraggableIndex =
      this.state.stopsWithoutDelays.find((stop) => !this.isDragDisabled(stop))
        ?.stopSequence || 0;
    // If dragged a stop to locked stop area, move it to the first unlocked stop sequence
    if (destination.index < firstDraggableIndex) {
      destinationIndex = firstDraggableIndex - 1;
    }

    const newStopsWithoutDelays = Array.from(this.state.stopsWithoutDelays);
    const deletedElement = newStopsWithoutDelays.splice(source.index, 1);
    newStopsWithoutDelays.splice(destinationIndex, 0, deletedElement[0]);
    this.setState({
      stopsWithoutDelays: newStopsWithoutDelays.map((stop, index) => {
        return {
          ...stop,
          stopSequence: index + 1,
        };
      }),
    });
  };

  isStopListUpdated = () => {
    // Check if user modifiyable stops were updated i.e lockStatus update or sequence update
    if (!this.state.stopsWithoutDelays) {
      return false;
    }
    const initialStops = sortStopsBySequence(
      this.state.routeData.stops
    ).filter(
      (stop) =>
        !isStopLockedPermanently(stop, this.state.routeData.currentStatus)
    );
    const updatedStops = this.state.stopsWithoutDelays.filter(
      (stop) =>
        !isStopLockedPermanently(stop, this.state.routeData.currentStatus)
    );

    const stops = updatedStops.find((stop, index) => {
      const initialStop = initialStops[index];
      return (
        stop.stopSequence === initialStop.stopSequence &&
        (stop.isLocked !== initialStop.isLocked ||
          stop.stopId !== initialStop.stopId)
      );
    });
    return Boolean(stops);
  };

  getDraggableItemStyle = (draggableStyle, lockPosition) => {
    const transformPosition = lockPosition ? { transform: "0px" } : {}; // disabled moving of locked columns when a column is dragged over them
    return {
      ...draggableStyle,
      ...transformPosition,
    };
  };

  // Creates a draggable item
  getDraggableItem = (provided, snapshot, stop, expandDriverStopList, geofenceWindow) => {
    const { stopId } = stop;
    const draggableItem = (
      <div
        key={`driver_stop_cards_container${stopId}`}
        id={stopId}
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        style={this.getDraggableItemStyle(
          provided.draggableProps.style,
          this.isDragDisabled(stop)
        )}
      >
        <Cards
          key={`driver_stop_cards_${stopId}`}
          stopData={stop}
          geofenceWindow={geofenceWindow}
          driverId={this.state.routeData.driverId}
          routeData={{ ...this.state.routeData, currentStatus: this.getEffectiveCurrentStatus() }}
          enableDispatchRouteResequence={this.enableDispatchRouteResequence}
          glEventHub={this.props.glEventHub}
          defaultExpanded={!stop.isStopCompleted || expandDriverStopList}
          resequenceMode={this.state.resequencingInProgress}
          isDriverCurrentStop={this.isDriverCurrentStop(stop.stopId)}
          onLockChanged={this.onLockChanged}
          updateNextStop={this.updateNextStop}
          enableRemovePro={this.props.configJSON.enableRemoveAndAddPro}
          enableAddNotesToPro={this.props.configJSON.enableAddNotesToPro}
          enableAddProToCompletedPro={this.props.configJSON.enableAddProToCompletedPro}
          enableReprocessDelivery={this.props.configJSON.enableReprocessDelivery}
          enableRevisitDeliveryStop={this.props.configJSON.enableRevisitDeliveryStop}
          viewStopImages={(proId) => () => this.onViewStopImages(stop,proId)}
          theme={this.props.theme}
          terminalCode= {this.props.userProfile.terminal.code}
          enableNoFreightCode={this.props.configJSON?.noFreightConfigParsed?.enableNoFreightCode}
        />
      </div>
    );
    if (snapshot.isDragging) {
      return ReactDOM.createPortal(draggableItem, this.portalItem); // Renders dragged item above all the elements inside body
    }
    return draggableItem;
  };

  handleAddPro = () => {
    this.setState({
      isAddProInProgress: true,
    });
  };

  cancelAddPro = () => {
    this.setState({
      isAddProInProgress: false,
    });
  };

  requiresDetailedRouteInfo = (placardsCount) => {
    return this.state.currentDriverRoutes.length > 1 || placardsCount > 0;
  }

  handleDropAndHookMenuOpen = () => {
    this.setState({
      isOpenDropHookMoveModal: true,
    });
  };

  onViewStopImages = (stop,proId=null) => {
    this.setState({
      viewStopImages: {
        terminalCode: this.props.userProfile.terminal.code,
        routeId: this.state.routeData.routeId,
        stopId: stop.stopId,
        isStopCompleted: stop.isStopCompleted,
        proNumbers: getProNumbers(stop.shipments),
        proId
      },
    });
  }

  onHideStopImages = () => {
    this.setState({
      viewStopImages: null
    })
  }

  checkIsBobTail = () =>{
    return this.state.routeData.trailerNumber === constants.TRAILER_NUMBER_FOR_BOBTAIL
  }

  getGeofenceWindow =(stopId,geofenceWindow = {})=> {
       return geofenceWindow[stopId.toUpperCase()] ?? {geoFenceArrivalTime:"", geoFenceDepartureTime:""};
  }

  render() {
    const { classes, theme} = this.props;
    const {
      routeData,
      isExpanded,
      resequencingInProgress,
      showPendingChangesWarning,
      showResequenceHelperText,
      showConfirmation,
    } = this.state;
    const totalPickups = routeData.totalPickups || 0;
    const totalDeliveries = getTotalDeliveryStops(routeData.stops);
    const totalUAPickups = totalUnAckPickupsValueGetter({data:routeData});
    const isStopListUpdated =
      resequencingInProgress && this.isStopListUpdated();
    const footerDetails = `${totalDeliveries} Deliveries | ${totalPickups} Pickups (${totalUAPickups} unacknowledged)`;
    const stopsWithoutDelays =
      this.state.stopsWithoutDelays ?? sortStopsBySequence(routeData.stops);
   
    if (!isExpanded) {
      return (
        <Paper
          className={`${classes.outerMostWrapper} ${classes.closedWrapper}`}
        >
          <Button
            className={classes.collapsedStopsStatus}
            color="primary"
            onClick={this.toggleExpand}
          >
            {`${routeData.driverName}'s Stops (${completedVsTotalStopsFormatter(
              routeData
            )})`}
            <ExpandLess className={classes.expandIcon} />
          </Button>
        </Paper>
      );
    }

    const isResequenceDisabled = !stopsWithoutDelays.length || this.shouldDisableActionForPreDispatch;
    const buttonColor = isStopListUpdated ? "primary" : null;
    const lowPriorityClass = this.state.resequencingInProgress
      ? classes.activeHeaderIcon
      : "";
    const hazmatPlacards =
      getRoutePlacards(routeData, this.props.DispatchStore.hazmatInfo ?? []) ??
      [];
    const enableAddPro =  this.props.configJSON.enableRemoveAndAddPro && !this.checkIsBobTail();
    const expandDriverStopList= this.props.DispatchStore.expandDriverStopList;
    const driverGeofenceWindow = this.props.DispatchStore.geofenceWindow[routeData.driverId.toUpperCase()];     
    return (
      <Paper className={classes.outerMostWrapper}>
        <div className={classes.headerContainer}>
          <div className={classes.detailsContainer}>
            <IconButton onClick={this.toggleExpand}>
              <ArrowBack className={classes.backButtonSize} />
            </IconButton>
            <div className={classes.driverNameContainer}>
              <StyledToolTip title={routeData.driverName}>
                <div className={classes.driverName}>{routeData.driverName}</div>
              </StyledToolTip>
              <div className={classes.driverStatusContainer}>
                <span className={classes.driverPhoneNo}>
                  {`Phone # ${routeData.driverPhoneNumber ? routeData.driverPhoneNumber : 'N/A'}`}
                </span>
              </div>
            </div>
          </div>
          <div className={classes.driverDetailsContainer}>
            <div className={classes.driverNumber}>
              {`# ${routeData.driverNumber}`}
            </div>
            {this.enableDispatchRouteResequence && (
              <div
                className={`${classes.stopIconStyles} ${
                  !isResequenceDisabled
                    ? classes.enableActiveIcon
                    : classes.disableIcon
                }`}
                onClick={
                  !isResequenceDisabled ? this.enableResequencing : null
                }
              >
                <StyledToolTip title="Resequence stops">
                  <div className="stop-list-icon-wrapper">
                    <LowPriority
                      className={`${classes.headerIcon} ${lowPriorityClass}`}
                    />
                  </div>
                </StyledToolTip>
              </div>
            )}
            <div
              className={`${classes.stopIconStyles} ${
                this.enableDropHookMove && !this.shouldDisableActionForPreDispatch
                  ? classes.enableActiveIcon
                  : classes.disableIcon
              }`}
              onClick={
                this.enableDropHookMove && !this.shouldDisableActionForPreDispatch ? this.handleDropAndHookMenuOpen : null
              }
            >
              <StyledToolTip
                title={
                  this.enableDropHookMove && !this.shouldDisableActionForPreDispatch
                    ? "Drop-Hook-Move"
                    : "Drop-Hook-Move (Disabled)"
                }
              >
                <div className="stop-list-icon-wrapper">
                  <LocalShippingOutlinedIcon
                    className={classes.headerIcon}
                    color={
                      this.enableDropHookMove && !this.shouldDisableActionForPreDispatch
                        ? theme.palette.primary.main
                        : theme.iconColor
                    }
                  />
                </div>
              </StyledToolTip>
            </div>
            {routeData.routeId ? (
              <div
                className={`${classes.stopIconStyles} ${
                  enableAddPro
                    ? classes.enableActiveIcon
                    : classes.disableIcon
                }`}
                onClick={enableAddPro ? this.handleAddPro : null}
              >
                <StyledToolTip
                  title={enableAddPro ? "Add pro" : "Add pro (Disabled)"}
                >
                  <div className="stop-list-icon-wrapper">
                    <AddBoxOutlined
                      className={
                        enableAddPro
                          ? classes.activeHeaderIcon
                          : classes.headerIcon
                      }
                    />
                  </div>
                </StyledToolTip>
              </div>
            ) : null}
            <IconButton aria-label="close" onClick={this.toggleExpand}>
              <Close className={classes.headerIcon} />
            </IconButton>
          </div>
        </div>
        <RefreshWarningBar
          onRefreshClick={this.refreshStopList}
          terminalOffset={this.props.DispatchStore.terminalOffset}
          driverId={routeData.driverId.toUpperCase()}
        />

        <div className={classes.contentContainer}>
          {!resequencingInProgress && (
            <div
              className={`${classes.lowerDetails} customScroll ${
                this.requiresDetailedRouteInfo(
                  hazmatPlacards.length
                )
                  ? classes.expandedLowerDetails
                  : ''
              }`}
            >
              <Details
                routeData={routeData}
                currentDriverRoutes={this.state.currentDriverRoutes}
                changeRouteData={this.changeRouteData}
                showTrailerScac= {this.props.configJSON.showTrailerScac}
                enableRestBreakInDelay={this.props.configJSON?.enableRestBreakInDelay}
              />
              {hazmatPlacards.length ? (
                <HazmatPlacards placards={hazmatPlacards} />
              ) : null}
            </div>
          )}

          {resequencingInProgress && showResequenceHelperText && (
            <ResequenceHelperText close={this.hideResequenceHelperText} />
          )}

          <div
            ref={this.cardContainerRef}
            className={`${classes.cardsContainer} customScroll`}
          >
            <DragDropContext onDragEnd={this.onDragEnd}>
              <Droppable droppableId="stopList">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {stopsWithoutDelays.map((stop, index) => (
                      <Draggable
                        key={stop.stopId}
                        draggableId={stop.stopId}
                        index={index}
                        isDragDisabled={this.isDragDisabled(stop)}
                      >
                        {(provided, snapshot) =>
                          this.getDraggableItem(provided, snapshot, stop, expandDriverStopList,this.getGeofenceWindow(stop.stopId,driverGeofenceWindow) )
                        }
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
            <TerminalCard
              userData={this.props.userData}
              routeData={this.props.routeData}
              currentDriverRoutes={this.state.currentDriverRoutes}
            />
          </div>
        </div>
        <div id="footer" className={classes.footer}>
          {resequencingInProgress ? (
            <div className={classes.footerAction}>
              <Button
                onClick={this.cancelResequence}
                variant="outlined"
                classes={{
                  root: `${classes.actionButton} ${classes.cancelButton}`,
                  text: classes.actionButtonText,
                  disabled: classes.cancelButtonDisabled,
                }}
              >
                Cancel
              </Button>
              <div className={classes.footerSpace} />
              <Button
                onClick={this.showConfirmationModal}
                variant="contained"
                color={buttonColor}
                classes={{
                  root: `${classes.actionButton} ${classes.saveButton}`,
                  text: classes.actionButtonText,
                }}
                size="medium"
                disabled={!isStopListUpdated}
              >
                Save Changes
              </Button>
            </div>
          ) : (
            `${footerDetails}`
          )}
        </div>

        {showPendingChangesWarning && (
          <Dialog
            title="Pending stop move changes"
            discardLabel="Discard"
            confirmLabel="Save changes"
            onClose={this.onClosePendingChangesWarning}
          >
            <div className={classes.dialogContent}>
              <div>There are pending stop move changes.</div>
              <div>
                Only sequence of stops which are locked will be retained on
                save.
              </div>
            </div>
          </Dialog>
        )}

        {showConfirmation && (
          <Dialog
            title="Confirm stop move"
            discardLabel="Cancel"
            confirmLabel="Save changes"
            onClose={this.onCloseConfirmation}
            contentProps
          >
            <div className={classes.dialogContent}>
              Only sequence of stops which are locked will be retained on save.
            </div>
          </Dialog>
        )}
        {this.state.isOpenDropHookMoveModal && <DropHookMoveModal
          open={this.state.isOpenDropHookMoveModal}
          routeData={routeData}
          currentDriverRoutes={this.state.currentDriverRoutes}
          handleClose={this.closeDropHookMoveModal}
        />}
        {this.state.isAddProInProgress && (
          <AddProDialog
            open={this.state.isAddProInProgress}
            handleClose={this.cancelAddPro}
            routeData={this.state.routeData}
          />
        )}

        {
          this.state.viewStopImages ? (
            <StopImagesDialog 
              showImages={this.state.viewStopImages.proId || this.state.viewStopImages.proNumbers?.[0] || Object.keys(STOP_IMAGES)[0]}
              {...this.state.viewStopImages}
              stops= {routeData.stops}
              close={this.onHideStopImages}
              apiName='GetImages'
            />
          ) : null
        }
      </Paper>
    );
  }
}

export default compose(
  withStyles(styles),
  withTheme(),
  withFeatureFlags,
  withSnackbar,
  withUserProfile,
  withAppConfig,
)(DriverPopup);
